var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll",class:_vm.opacity},[_c('div',{staticClass:"socials mouse"}),_vm._v(" "),_c('svg',{staticClass:"line",attrs:{"version":"1.1","height":"110","width":"40"}},[_c('line',{attrs:{"x1":"20","y1":"0","x2":"20","y2":"110"}}),_vm._v(" "),_c('line',{attrs:{"x1":"20","y1":"110","x2":"13","y2":"102"}}),_vm._v(" "),_c('line',{attrs:{"x1":"20","y1":"110","x2":"27","y2":"102"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a69ef11","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/socials.vue
// module id = 298
// module chunks = 0